import { Stack, styled } from "@mui/material";
import { BORDER_COLORS } from "../../../../constants";

const ProductCard = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  border: `1px solid ${BORDER_COLORS.default}`,
  borderTop: "none",

  "&:first-of-type": {
    borderTop: `1px solid ${BORDER_COLORS.default}`,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },

  "&:last-of-type": {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export default ProductCard;